<template>
  <div class="bordered-group vs-card vs-con-block mt-5">
    <div class="vs-card-content">
      <div class="vx-row ">
        <div class="vx-col w-full">
          <vs-table max-items="10" :data="payments">
            <template slot="header">
              <div class="vx-row  w-full mb-1 mr-0 ml-0 p-0">
                <div class="vx-col w-1/3">
                  <h6>ข้อมูลการชำระเงิน</h6>
                </div>
                <div class="vx-col w-2/3 flex justify-end m-0 p-0">
                  <vs-button color="warning" type="filled" icon-pack="feather" icon="icon-chevrons-right"  class="mr-1" @click="onPressedCalculate()" v-if="visibilityCalculateButton">ประมวณผล</vs-button>
                  <vs-button color="success" type="filled" icon-pack="feather" icon="icon-plus"  class="mr-1"  @click="onPressedActiveAddQrPayment()">สร้าง QR CODE</vs-button>
                  <vs-button color="success" type="filled" icon-pack="feather" icon="icon-plus"  @click="onPressedActiveAddPayment()">เพิ่มข้อมูล</vs-button>
                </div>
              </div>
            </template>

            <template slot="thead">
              <vs-th >#</vs-th>
              <vs-th >วันที่ชำระ</vs-th>
              <vs-th >ประเภทการชำระ</vs-th>
              <vs-th >จำนวน</vs-th>
              <vs-th >ค่าธรรมเนียม</vs-th>
              <vs-th >เบี้ยปรับ</vs-th>
              <vs-th >ดอกเบี้ย</vs-th>
              <vs-th >เงินต้น (ดอกเบี้ยล่วงหน้า)</vs-th>
              <vs-th class="col-createdBy">ผู้บันทึก</vs-th>
              <vs-th class="col-approved">สถานะประมวลผล</vs-th>
              <vs-th class="col-actions"></vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="row" :key="index" v-for="(row, index) in data">
                <vs-td>{{ data.length - index }}</vs-td>
                <vs-td>{{ row.paymentDateLocalTh }}</vs-td>
                <vs-td>
                  {{ row.paymentTypeName }}
                </vs-td>
                <vs-td class="text-right">{{ row.paymentAmount | numberFormat }}</vs-td>
                <vs-td class="text-right">{{ row.paymentAmountDetail !== null ? $options.filters.numberFormat(row.paymentAmountDetail.paidFee) : '-' }}</vs-td>
                <vs-td class="text-right">{{ row.paymentAmountDetail !== null ? $options.filters.numberFormat(row.paymentAmountDetail.paidPenalty) : '-' }}</vs-td>
                <vs-td class="text-right">{{ row.paymentAmountDetail !== null ? $options.filters.numberFormat(row.paymentAmountDetail.paidInterest) : '-' }}</vs-td>
                <vs-td class="text-right">{{ row.paymentAmountDetail !== null ? $options.filters.numberFormat(row.paymentAmountDetail.paidPrinciple) : '-' }}({{ row.paymentAmountDetail !== null ? $options.filters.numberFormat(row.paymentAmountDetail.balanceRemain) : '-' }})</vs-td>
                <vs-td>{{ row.createByFullName }}<br>{{ row.createdAtLocalTh }}</vs-td>
                <vs-td>
                  <vs-chip :color="row.processed ? 'success' : 'warning'">{{ row.processed ? 'ประมวลผลแล้ว' : 'รอประมวลผล' }}</vs-chip>
                </vs-td>
                <vs-td>
                  <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end" v-if="!row.processed">
                    <vx-tooltip text="แก้ไขข้อมูลการชำระเงิน">
                      <vs-button  class="mr-1" color="warning" type="filled" icon-pack="feather" icon="icon-edit" @click="onPressedActiveUpdatePayment(row)" v-if="row.paymentType === IPaymentType.operator"></vs-button>
                    </vx-tooltip>
                    <vx-tooltip text="ลบข้อมูลการชำระเงิน">
                      <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-trash" @click="onPressedDelPayment(row.id)" v-if="row.paymentType === IPaymentType.operator || row.paymentType === IPaymentType.qrCode && isRoot"></vs-button>
                    </vx-tooltip>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>

    </div>

    <vs-popup
      :active.sync="paymentModal.active"
      :title="paymentModal.title"
      class="custom-popup"
    >
      <div class="popup-content">
        <ValidationObserver v-slot="{ handleSubmit }" ref="form">
          <form @submit.prevent="handleSubmit">
          <div class="vx-row">
            <div class="vx-col w-1/3">
              <ValidationProvider name="วันที่" rules="required" v-slot="{ errors }" >
                <label class="text-sm">วันที่*</label>
                <flat-pickr :config="configDatePayment" class="w-full" v-model="paymentModal.date"/>
                <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-1/3">
              <ValidationProvider name="จำนวน" :rules="{ required: true, min_value: 0.01 }" v-slot="{ errors }" >
                <label class="text-sm">จำนวน*</label>
                <vs-input type="number" class="w-full" v-model="paymentModal.amount"/>
                <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-1/6">
              <ValidationProvider name="ชำระเงินต้น" rules="" v-slot="{ errors }" >
                <label class="text-sm">ชำระเงินต้น</label>
                <vs-checkbox v-model="paymentModal.paymentPrinciple"></vs-checkbox>
                <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-1/6">
              <ValidationProvider name="ปรับยอด" rules="" v-slot="{ errors }" >
                <label class="text-sm">ปรับยอด</label>
                <vs-checkbox v-model="paymentModal.adjustment"></vs-checkbox>
                <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <validation-provider name="หมายเหตุ" rules="" v-slot="{ errors }">
                <label class="vs-input--label">หมายเหตุ*</label>
                <vs-textarea  v-model="paymentModal.paymentRemark" rows="5"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          </form>
        </ValidationObserver>
      </div>
      <div class="popup-footer">
        <vs-button color="success" @click="onPressedAcceptAddPayment">บันทึก</vs-button>
        <vs-button color="danger" @click="paymentModal.active = false">ยกเลิก</vs-button>
      </div>
    </vs-popup>

    <vs-popup
      :active.sync="qrPaymentModal.active"
      title="สร้าง QR CODE (Admin)"
      class="custom-popup"
    >
      <div class="popup-content">
        <ValidationObserver v-slot="{ handleSubmit }" ref="form2">
          <form @submit.prevent="handleSubmit">
            <div class="vx-row">
              <div class="vx-col w-1/2">
                <ValidationProvider name="จำนวน" :rules="{ required: true, min_value: 0.01 }" v-slot="{ errors }" >
                  <label class="text-sm">จำนวน*</label>
                  <vs-input type="number" class="w-full" v-model="qrPaymentModal.amount"/>
                  <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col w-1/2">
                <ValidationProvider name="ไม่กำหนดยอดชำระขั้นต่ำ" rules="" v-slot="{ errors }" >
                  <label class="text-sm">ไม่กำหนดยอดชำระขั้นต่ำ</label>
                  <vs-checkbox v-model="qrPaymentModal.skipLimit"></vs-checkbox>
                  <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
                </ValidationProvider>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
      <div class="popup-footer">
        <vs-button color="success" @click="onPressedAcceptAddQrPayment">บันทึก</vs-button>
        <vs-button color="danger" @click="qrPaymentModal.active = false">ยกเลิก</vs-button>
      </div>
    </vs-popup>

    <vs-popup title="ชำระผ่าน QR CODE" :active.sync="paymentPopup" class="fixed-width-popup">
      <div class="vx-row">
        <div class="vx-col mr-auto ml-auto">
          <div class="vx-row flex" v-if="_qrPayment.paidFee > 0">
            <span class="vx-col flex-1 text-left label">ค่าธรรมเนียม</span>
            <span class="vx-col flex-1 text-right label-bold">{{ _qrPayment.paidFee | numberFormat }}</span>
          </div>
          <div class="vx-row flex" v-if="_qrPayment.paidPenalty > 0">
            <span class="vx-col flex-1 text-left label">เบี้ยปรับ</span>
            <span class="vx-col flex-1 text-right label-bold">{{ _qrPayment.paidPenalty | numberFormat }}</span>
          </div>
          <div class="vx-row flex" v-if="_qrPayment.paidInterest > 0">
            <span class="vx-col flex-1 text-left label">ดอกเบี้ย</span>
            <span class="vx-col flex-1 text-right label-bold">{{ _qrPayment.paidInterest | numberFormat }}</span>
          </div>
          <div class="vx-row flex" v-if="_qrPayment.paidPrinciple > 0">
            <span class="vx-col flex-1 text-left label">เงินต้น</span>
            <span class="vx-col flex-1 text-right label-bold">{{ _qrPayment.paidPrinciple | numberFormat }}</span>
          </div>
          <div class="vx-row flex" v-if="_qrPayment.paidContractFee > 0">
            <span class="vx-col flex-1 text-left label">{{ `${$options.filters.qrPaymentTypeName(IQrPaymentType.contractFee)}`}}</span>
            <span class="vx-col flex-1 text-right label-bold">{{ _qrPayment.paidContractFee | numberFormat }}</span>
          </div>
          <div class="vx-row flex" v-if="_qrPayment.paidTaxAmount > 0">
            <span class="vx-col flex-1 text-left label">{{ `${$options.filters.qrPaymentTypeName(IQrPaymentType.taxAmount)}`}}</span>
            <span class="vx-col flex-1 text-right label-bold">{{ _qrPayment.paidTaxAmount | numberFormat }}</span>
          </div>
          <div class="vx-row flex" v-if="_qrPayment.paidProcessingFee > 0">
            <span class="vx-col flex-1 text-left label">{{ `${$options.filters.qrPaymentTypeName(IQrPaymentType.processingFee)}`}}</span>
            <span class="vx-col flex-1 text-right label-bold">{{ _qrPayment.paidProcessingFee | numberFormat }}</span>
          </div>
          <div class="vx-row flex" v-if="_qrPayment.paidCourtOrderExpense > 0">
            <span class="vx-col flex-1 text-left label">{{ `${$options.filters.qrPaymentTypeName(IQrPaymentType.courtOrderExpense)}`}}</span>
            <span class="vx-col flex-1 text-right label-bold">{{ _qrPayment.paidCourtOrderExpense | numberFormat }}</span>
          </div>
          <div class="vx-row flex" v-if="_qrPayment.balanceRemain > 0">
            <span class="vx-col flex-1 text-left label">ดอกเบี้ยรับล่วงหน้า</span>
            <span class="vx-col flex-1 text-right label-bold">{{ _qrPayment.balanceRemain | numberFormat }}</span>
          </div><br>
          <br>
          <div class="vx-row flex mb-1">
            <span class="vx-col flex-1 text-left label">ยอดรวม</span>
            <div class="vx-col flex-1 text-right"><span class="money-bold">{{ _qrPayment.amount | numberFormat }} </span> <span class="label-bold">บาท</span></div>
          </div><br>
          <div class="vx-row flex mb-1">
            <span class="vx-col flex-1 text-left label-bold">ชำระภายในวันที่ {{ _qrPayment.dueDate }}</span>
          </div>
          <div class="vx-row flex mb-1">
            <div class="mr-auto ml-auto" ref="qrcode"></div>
          </div>
          <div class="vx-row flex mb-1">
            <span class="vx-col flex-1 text-left label">ใช้แอปพลิเคชันธนาคารสแกน QR CODE นี้ เพื่อชำระเงินรองรับทุกธนาคาร โดยไม่มีค่าธรรมเนียม</span>
          </div>
          <div class="vx-row flex mb-1">
            <span class="vx-col flex-1 text-left label-link cursor-pointer"><a @click="onPressedReload()"><u><b>คลิกเพื่ออัพเดตยอด</b></u></a></span>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import Divider from "@/views/components/vuesax/divider/Divider.vue";
import * as QRCode from 'easyqrcodejs'
import {createNamespacedHelpers} from "vuex";
import {visibility} from "tailwindcss/lib/plugins";
import moment from "moment";
import { Thai } from 'flatpickr/dist/l10n/th'
import 'flatpickr/dist/themes/dark.css';
import flatPickr from "vue-flatpickr-component";
import {IPaymentType, IQrPaymentType} from "@/constants/interface";
import {isRoot as fncIsRoot} from "@/utils";
const {mapActions: mapAccountingActions, mapState: mapAccountingFields} = createNamespacedHelpers('Accounting');

export default {
  name: 'PaymentInfoTab',
  components: {
    Divider,
    flatPickr
  },
  data() {
    return {
      clearTransactionsPopup: {
        active: false,
        date: moment().format('DD-MM-YYYY'),
      },
      paymentModal: {
        active: false,
        type: 'add',
        title: 'เพิ่มข้อมูลการชำระเงิน',
        id: null,
        date: moment().format('DD-MM-YYYY'),
        amount: 0,
        paymentPrinciple: false,
        adjustment: false,
        paymentRemark: "",
      },
      paymentPopup: false,
      qrPaymentModal: {
        active: false,
        amount: 0,
        skipLimit: false,
      },
    };
  },
  computed: {
    ...mapAccountingFields(['contractDetail','contractDetailPayments', 'qrPayment']),
    IQrPaymentType() {
      return IQrPaymentType
    },
    IPaymentType() {
      return IPaymentType
    },
    isRoot () {
      return fncIsRoot();
    },
    _qrPayment(){
      if(!this.qrPayment) return {}
      return {
        paidFee: this.qrPayment.paidFee,
        paidPenalty: this.qrPayment.paidPenalty,
        paidInterest: this.qrPayment.paidInterest,
        paidPrinciple: this.qrPayment.paidPrinciple,
        paidContractFee: this.qrPayment.paidContractFee,
        paidTaxAmount: this.qrPayment.paidTaxAmount,
        paidProcessingFee: this.qrPayment.paidProcessingFee,
        paidCourtOrderExpense: this.qrPayment.paidCourtOrderExpense,
        balanceRemain: this.qrPayment.balanceRemain,
        dueDate: this.qrPayment.dueDate,
        amount: this.qrPayment.amount,
        createdAt: this.qrPayment.createdAt,
      }
    },
    configDateClearTransactions(){
      const vm = this
      let minDate = null
      let maxDate = null

      if(vm.contractDetail != null) {
        const { contractLoanDate } = vm.contractDetail
        if(contractLoanDate){
          minDate = moment(contractLoanDate).add(1, 'days').format('DD-MM-YYYY')
        }
      }

      return {
        monthSelectorType: "static",
        allowInput: true,
        locale: Thai,
        dateFormat: "d-m-Y",
        minDate,
        maxDate
      }
    },
    configDatePayment(){
      const vm = this
      let minDate = null
      let maxDate = null
      let lastUpdateDate = null

      if(vm.contractDetail) {
        const { loan } = vm.contractDetail
        if(loan){
          const { lastUpdate } = loan
          lastUpdateDate = moment(lastUpdate).add(1, 'days')
          minDate = lastUpdateDate.format('DD-MM-YYYY')
        }
      }

      return {
        monthSelectorType: "static",
        allowInput: true,
        locale: Thai,
        dateFormat: "d-m-Y",
        minDate,
        maxDate
      }
    },
    visibilityCalculateButton() {
      if (!this.contractDetailPayments) return false;
      const unProcessPayments = this.contractDetailPayments.filter(({paymentAmountDetail}) => !paymentAmountDetail);
      return unProcessPayments.length > 0;
    },
    payments() {
      if (!this.contractDetailPayments) return null;
      return [...this.contractDetailPayments]
        .sort(({ paymentDate: aPaymentDate, createdAt: aCreatedAt }, { paymentDate: bPaymentDate, createdAt: bCreatedAt }) => {
          const paymentDateDiff = new Date(bPaymentDate) - new Date(aPaymentDate);
          if (paymentDateDiff !== 0) {
            return paymentDateDiff;
          }
          return new Date(bCreatedAt) - new Date(aCreatedAt);
        })
        .map((payment) => {
          const {
              id,
              adjustment,
              paymentType,
              paymentDate,
              paymentAmount,
              paymentPrinciple,
              paymentRemark,
              paymentTypeName,
              createdAtLocalTh,
              createByFullName,
              paymentDateLocalTh,
              processed,
              paymentAmountDetail
          } = payment;
          return {
            id,
            adjustment,
            paymentType,
            paymentDate,
            paymentAmount,
            paymentPrinciple,
            paymentRemark,
            paymentTypeName,
            createdAtLocalTh,
            createByFullName,
            paymentDateLocalTh,
            processed,
            paymentAmountDetail,
          }
        })
    },
  },
  methods: {
    ...mapAccountingActions(['getContractDetail', 'calculateContractDetailPayment', 'createContractDetailPayment', 'updateContractDetailPayment', 'deleteContractDetailPayment', 'createQrPayment']),
    visibility() {
      return visibility
    },
    async onPressedCalculate() {
      const { id: contractId } = this.$route.params;
      const { calculateContractDetailPayment } = this;
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'ยืนยันการประมวลผล',
        text: 'คุณต้องการประมวลผลข้อมูลการชำระเงินใช่หรือไม่?',
        acceptText: 'ใช่',
        accept: async () => {
          await calculateContractDetailPayment({
            contractId,
          })
        }
      })
    },
    async onPressedActiveAddQrPayment() {
      const vm = this
      vm.qrPaymentModal.active = true
      vm.qrPaymentModal.amount = 0
      vm.qrPaymentModal.skipLimit = false
    },
    async onPressedAcceptAddQrPayment () {
      // chang from  btnQrPayment to onPressedAcceptAddQrPayment
      const vm = this
      const contractId  = this.$route.params.id;
      vm.$refs['form2'].validate().then(async success => {
        if (!success) {
          return
        }
        const { createQrPayment } = vm
        const result = await createQrPayment({
          contractId: contractId,
          form: { type: IQrPaymentType.custom , amount: parseFloat(vm.qrPaymentModal.amount), skipLimit: vm.qrPaymentModal.skipLimit }
        })
        if(result){
          vm.qrPaymentModal.active = false;
          const { qrPayment } = vm
          const { taxId, suffix, ref1, ref2, amount: QrAmount } = qrPayment
          if(vm.qrcode) vm.qrcode.clear()
          if(result === true){
            const cr = '\r'
            const text = '|'
              + taxId
              + suffix + cr
              + ref1 + cr
              + ref2 + cr
              + QrAmount.toFixed(2).replace(/\./g, '')

            // console.log("text: ", text)
            // console.log("qrPayment: ", qrPayment)

            const options = {
              text: text,
              width: 256,
              height: 256,
              colorDark: "#000000",
              colorLight: "#ffffff",
              correctLevel: QRCode.CorrectLevel.M,
              // ==== Title
              title: '', // content
              titleFont: "bold 18px Arial", //font. default is "bold 16px Arial"
              titleColor: "#004284", // color. default is "#000"
              titleBgColor: "#fff", // background color. default is "#fff"
              titleHeight: 10, // height, including subTitle. default is 50
              titleTop: 25, // draws y coordinates. default is 30

              // ==== SubTitle
              // subTitle: 'QR subTitle', // content
              // subTitleFont: "14px Arial", // font. default is "14px Arial"
              // subTitleColor: "#004284", // color. default is "gray"
              // subTitleTop: 40, // draws y coordinates. default is 50

              // ==== Logo
              // logo: "../images/qrcodelogo/Thai_QR_Payment_Logo-03.png", // Relative address, relative to easy.qrcode.min.js
              logo: require("@/assets/images/logo/logo-wel-barcode.png"), // Relative address, relative to easy.qrcode.min.js
              // logo:"http://127.0.0.1:8020/easy-qrcodejs/demo/logo.png",
              logoWidth: 40, // widht. default is automatic width
              logoHeight: 40, // height. default is automatic height
              // logoBgColor:'#fffff', // Logo backgroud color, Invalid when logBgTransparent is true; default is '#ffffff'
              logoBgTransparent: true, // Whether use transparent image, default is false
            }
            vm.paymentPopup = true
            vm.qrcode  = new QRCode(vm.$refs.qrcode, options);
          }else{
            alert(result.graphQLErrors[0].message)
          }
        }
      });
    },
    async onPressedReload() {
      const vm = this
      const { getContractDetail } = vm;
      const contractId  = this.$route.params.id;
      await getContractDetail({id: contractId});
    },
    async onPressedActiveAddPayment() {
      const vm = this
      vm.paymentModal.active = true
      vm.paymentModal.type = 'add'
      vm.paymentModal.id = null
      vm.paymentModal.title = 'เพิ่มข้อมูลการชำระเงิน'
      vm.paymentModal.date = moment().format('DD-MM-YYYY');
      vm.paymentModal.amount = 0
      vm.paymentModal.paymentPrinciple = false
      vm.paymentModal.adjustment = false
      vm.paymentModal.paymentRemark = ""
    },
    async onPressedActiveUpdatePayment(row) {
      const vm = this
      vm.paymentModal.active = true
      vm.paymentModal.type = 'update'
      vm.paymentModal.id = row.id
      vm.paymentModal.title = 'แก้ไขข้อมูลการชำระเงิน'
      vm.paymentModal.date = moment(row.paymentDate).format('DD-MM-YYYY');
      vm.paymentModal.amount = row.paymentAmount
      vm.paymentModal.paymentPrinciple = row.paymentPrinciple
      vm.paymentModal.adjustment = row.adjustment
      vm.paymentModal.paymentRemark = row.paymentRemark
    },
    async onPressedAcceptAddPayment() {
      const vm = this
      const contractId  = this.$route.params.id;
      const {createContractDetailPayment, updateContractDetailPayment} = vm;
      vm.$refs['form'].validate().then(async success => {
        if (!success) {
          return
        }
        // console.log("vm.paymentModal.type:", vm.paymentModal.type)
        const receiveDate = vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.paymentModal.date.trim())
        const paymentDate = vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.paymentModal.date.trim())
        if(vm.paymentModal.type === 'add') {
          await createContractDetailPayment ({
            contractId,
            form: {
              receiveDate: receiveDate,
              paymentDate: paymentDate,
              paymentAmount: parseFloat(vm.paymentModal.amount),
              paymentPrinciple: vm.paymentModal.paymentPrinciple,
              adjustment: vm.paymentModal.adjustment,
              paymentRemark:  vm.paymentModal.paymentRemark,
            }
          });
        }else if(vm.paymentModal.type === 'update') {
          await updateContractDetailPayment({
            id: vm.paymentModal.id,
            form: {
              receiveDate: receiveDate,
              paymentDate: paymentDate,
              paymentAmount: parseFloat(vm.paymentModal.amount),
              paymentPrinciple: vm.paymentModal.paymentPrinciple,
              adjustment: vm.paymentModal.adjustment,
              paymentRemark:  vm.paymentModal.paymentRemark,
            }
          })
        }
        vm.paymentModal.active = false;
      })
    },
    async onPressedDelPayment(id) {
      const vm = this
      const { deleteContractDetailPayment } = vm;
      vm.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'ยืนยันการลบข้อมูล',
        text: 'คุณต้องการลบข้อมูลใช่หรือไม่?',
        acceptText: 'ใช่',
        accept: async () => {
          await deleteContractDetailPayment({
            id,
            vm
          })
        }
      })
    },
  }
}
</script>

<style scoped>
.vx-row {
  margin-bottom: 15px;
}

.col-createdBy {
  width: 200px;
}

.col-approved {
  width: 130px;
}

.col-actions {
  width: 100px;
}

.custom-popup .vs-popup {
  width: 600px;
}
.popup-content {
  padding: 10px;
}
.popup-footer {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  border-top: 1px solid #e0e0e0;
}
.popup-footer .vs-button + .vs-button {
  margin-left: 10px;
}


.fixed-width-popup {
  width: 400px !important;
  height: auto !important;
}


</style>
